import { textStyles, colors, loadingDark, loadingLight } from '../../shared/styles';

export const styles = {
  pseudoStyles: (isMobile, cursor) => `
    .start-list-row:hover {
      background: ${colors.lightGrey} !important;
      cursor: ${cursor};
    }
    .start-list-row:hover .athName-display {
      text-decoration: underline !important;
      text-decoration-color: ${colors.greyLine} !important;
      -webkit-text-decoration-color: ${colors.greyLine} !important;
    }
  `,
  listContainer: {
      position: 'relative',
      minHeight: 290,
  },

  tableHeaders: {
      display: 'flex',
      paddingBottom: 7,
      textAlign: 'center',
      alignItems: 'flex-end',
      ...textStyles.sectionHead
  },
  leftCell: {
      textAlign: 'left',
  },
  tableRow: {
      display: 'flex',
      alignItems: 'center',
      padding: '15px 0',
      borderTop: '1px solid '+ colors.greyLine,
  },
  midData: {
      alignItems: 'center',
  },
  dataColumn: {
      textAlign: 'center',
      fontSize: 18,
      lineHeight: '1em'
  },
  timeColumn: (isClaimed = false) => ({
      textAlign: 'center',
      fontFamily: isClaimed ? 'BebasNeueBold, serif' : '',
      fontSize: 18,
      lineHeight: '1em',
  }),
  ageRow: {
      marginBottom: 5,

      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
  },
  loadingContainer: (show) => ({
    position: 'absolute',
    zIndex: 2,
    top: 20,
    left: 0,
    width: '100%',
    pointerEvents: 'none',
    opacity: (show) ? 1 : 0,
    transition: 'opacity 0.3s',
  }),
  loadingRow: {
		display: 'flex',
		alignItems: 'center',
		padding: '15px 0',
  },
  loadingDatum: {
  	width: '80%',
  	height: 22,
  	margin: '0 auto',
  	...loadingLight,
  },
  loadingTime: {
  	width: '90%',
  	height: 32,
  	margin: '0 auto',
  	...loadingLight,
  },
  loadingButton: {
  	display: 'inline-block',
  	width: 56,
  	height: 46,
  	marginTop: 2,
  	borderRadius: '3px',
  	...loadingLight,
  },

  loadingProfileColumn: {
  	display: 'flex',
  },
  loadingAvatar: {
  	position: 'relative',
  	right: 2,
  	height: 68,
  	width: 68,
  	borderRadius: '50%',
  	marginRight: 25,
    ...loadingLight,
  },
  loadingProfile: {
  	flex: '1',
  	paddingTop: 8,
  },
  loadingTitle: {
    width: '50%',
    height: 24,
    marginBottom: 3,
    ...loadingDark,
  },
  loadingDetail: {
    width: '95%',
    height: 20,
    ...loadingLight,
  },
};



/** WEBPACK FOOTER **
 ** ./components/startList/styles.js
 **/